import { useTranslation } from '@crehana/i18n';
import { CustomNextImage as Image } from '@crehana/next';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import { Col, Container, Row } from '@crehana/ui';

import { imgixLoader } from '@/shared/utils/imgixLoader';

import { ChatIcon, UserIcon } from './Pictograms';

const IMAGE =
  'https://crehana-vercel-images-prd.imgix.net/public/crehana-frontend-mf/48506e8b-c117-4c70-8c07-bca21a316da3-522x372.gif';

interface BulletProps {
  icon: 'chat' | 'user';
  title: string;
  description: string;
}

const Bullet: React.FC<BulletProps> = ({ icon, title, description }) => {
  return (
    <div className="flex items-start mb-32">
      <div className="mr-16">
        {icon === 'chat' ? <ChatIcon /> : <UserIcon />}
      </div>
      <div className="flex flex-col">
        <span className="tw-font-subtitle3 mb-8">{title} </span>
        <p className="tw-font-body3">{description} </p>
      </div>
    </div>
  );
};

const Resources = ({
  errorMessage,
}: {
  errorMessage?: string | null | undefined;
}) => {
  const { t } = useTranslation();

  return (
    <Container className="flex items-start flex-grow mt-20">
      <section>
        <Row>
          <Col sm={6} md={6} lg={6} className="flex flex-col justify-start">
            <p className="tw-font-h3 tw-text-neutral-dark-800 tw-mb-2">
              {t('RESOURCES_TITLE')}
            </p>
            <Bullet
              icon="chat"
              title={t('RESOURCES_SUBTITLE_1')}
              description={t('RESOURCES_DESCRIPTION_1')}
            />
            <Bullet
              icon="user"
              title={t('RESOURCES_SUBTITLE_2')}
              description={t('RESOURCES_DESCRIPTION_2')}
            />
          </Col>
          <Col sm={6} md={6} lg={6}>
            <Image
              src={IMAGE}
              loader={imgixLoader}
              layout="intrinsic"
              height={400}
              width={550}
              alt="Resources"
              className="zIndex-50"
              loading="lazy"
              quality={100}
            />
            {errorMessage && (
              <p className="font-subtitle4 text-red-main mt-12">
                {errorMessage}
              </p>
            )}
          </Col>
        </Row>
      </section>
    </Container>
  );
};

export default Resources;
